export const WorkerEmbeddedPages = {
  DashboardWorker: "dashboard-worker",
  ProfileWorker: "profile-worker",
} as const;

export type WorkerEmbeddedPage =
  (typeof WorkerEmbeddedPages)[keyof typeof WorkerEmbeddedPages];

export const CompanyEmbeddedPages = {
  Contractors: "contractors",
  CustomAttributes: "custom-attributes",
  CustomPaperwork: "custom-paperwork",
  Dashboard: "dashboard",
  Employees: "employees",
  I9: "i9",
  Reports: "reports",
  WorkLocations: "work-locations",
} as const;

export type CompanyEmbeddedPage =
  (typeof CompanyEmbeddedPages)[keyof typeof CompanyEmbeddedPages];
